var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBootcampDefaultIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8224",
    "data-name": "Group 8224",
    transform: "translate(-66.293 -209.027)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3552",
    "data-name": "Rectangle 3552",
    width: 30,
    height: 29.872,
    transform: "translate(66.293 209.155)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8221",
    "data-name": "Group 8221",
    transform: "translate(66.293 209.027)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3553",
    "data-name": "Rectangle 3553",
    width: 30,
    height: 29.872,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8223",
    "data-name": "Group 8223",
    transform: "translate(67.734 214.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3640",
    "data-name": "Path 3640",
    d: "M92.108,215.764h2.6v15.691H83.746s-.411,1.523-1.521,1.523-2.139.016-2.139.016c-1.268,0-1.538-1.539-1.538-1.539H67.588V215.764h2.6",
    transform: "translate(-67.588 -213.582)",
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8222",
    "data-name": "Group 8222",
    transform: "translate(6.023 5.322)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_673",
    "data-name": "Line 673",
    x2: 4.096,
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_674",
    "data-name": "Line 674",
    x2: 4.096,
    transform: "translate(0 4.602)",
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_675",
    "data-name": "Line 675",
    x2: 4.096,
    transform: "translate(10.977)",
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_676",
    "data-name": "Line 676",
    x2: 4.096,
    transform: "translate(10.977 4.602)",
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3554",
    "data-name": "Rectangle 3554",
    d: "M0,0H8.377a2.6,2.6,0,0,1,2.6,2.6V15.246a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(2.602)",
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3555",
    "data-name": "Rectangle 3555",
    d: "M2.6,0h8.377a0,0,0,0,1,0,0V15.246a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2.6A2.6,2.6,0,0,1,2.6,0Z",
    transform: "translate(13.54)",
    fill: "none",
    stroke: "#de1186",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootcampDefaultIcon);
export default __webpack_public_path__ + "static/media/bootcamp-default-icon.dbc9402331a0c70cdc99f8904666205c.svg";
export { ForwardRef as ReactComponent };